import { render, staticRenderFns } from "./AddProviders.vue?vue&type=template&id=3a51c758&"
import script from "./AddProviders.vue?vue&type=script&lang=js&"
export * from "./AddProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports